import { Card, Col, Nav, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { MAXIMIZE_OR_MINIMIZE_IMAGE_SECTION } from "../../../store/actions";
import _ from "lodash";
import { useState } from "react";
import 'react-aspect-ratio/aspect-ratio.css'
import ImagePopup from "./ImagePopup";
import PerfectScrollbar from 'react-perfect-scrollbar';
import { IMAGE_OPTIONS_TYPE } from "../../../Common/constants";
import { Icon } from "@iconify/react";
import ToolTip from "../Common/Tooltip";

const ExpandedImageView = props => {

    const ALL = "All", LABEL = "Label", COMPONENT = "Component";
    const ZOOM_LEVEL = [1, 2, 3];

    const dispatch = useDispatch();
    const [utils, setUtils] = useState({
        selectedImage: { image: "", id: "" },
        rotation: 0,
        currentImageTab: ALL,
        zoomLevel: ZOOM_LEVEL[1]
    });

    const currentImages = useSelector(state => {
		if(!_.isEmpty(props?.target) && props?.target === IMAGE_OPTIONS_TYPE[0]) {
			return state.equipment.equipmentPictures;
		}
		return {
            [`${LABEL}`]: state.equipment.selectedComponent?.labelPictures,
            [`${COMPONENT}`]: state.equipment.selectedComponent?.componentPictures
        };
	}, (oldState, newState) => _.isEqual(oldState, newState));

    const checkIfCurrentImageTypeIsComponent = () => _.isEqual(props?.target, IMAGE_OPTIONS_TYPE[1]);

    const getPictures = () => {

        let imgObj = {};
        const isCurrentImageTypeComponent = checkIfCurrentImageTypeIsComponent();

        if(isCurrentImageTypeComponent) {
            if(utils.currentImageTab === ALL) {
                imgObj = { ...currentImages?.[COMPONENT], ...currentImages?.[LABEL] };
            }
            else if(utils.currentImageTab === COMPONENT) {
                imgObj = { ...currentImages?.[COMPONENT] };
            }
            else {
                imgObj = { ...currentImages?.[LABEL] };
            }
        }
        else {
            imgObj = currentImages;
        }

        return (
            !_.isEmpty(imgObj) ?
                <PerfectScrollbar style={{ width: "100%", height: isCurrentImageTypeComponent ? "500px" : "550px" }}>
                    <Row className="w-100 h-100">
                        {
                            Object.keys(imgObj).map((imageId) =>
                                <Col
                                    onClick={() => setUtils({ ...utils, selectedImage: { image: imgObj[imageId], id: imageId } })}
                                    className="p-1 cursor-pointer" sm={12} xs={12} md={6} lg={6} xl={6}
                                >
                                    {
                                        <div
                                            onMouseEnter={(event) => magnifyImage(event)} onMouseLeave={(event) => deMagnifyImage(event)}
                                            className={`zoom-container`}
                                        >
                                            <img alt="" src={imgObj[imageId]} className={"original-image"} />
                                            <div className={`zoomed-image zoom-l${utils.zoomLevel}`}></div>
                                        </div>
                                    }
                                </Col>
                            )
                        }
                    </Row>
                </PerfectScrollbar>
                    :
                <div className="text-center font-weight-bold">
                    NO IMAGES FOUND
                </div>
        )
    }

    const magnifyImage = (event) => {
        const imageContainer = event.currentTarget;
        const originalImage = imageContainer.querySelector(".original-image");
        const zoomedImage = imageContainer.querySelector(".zoomed-image");
        
        zoomedImage.style.backgroundImage = `url(${originalImage.src})`;
        zoomedImage.style.display = "block";

        imageContainer.addEventListener("mousemove", (e) => {
            const { left, top, width, height } = imageContainer.getBoundingClientRect();
            const xPercent = ((e.clientX - left) / width) * 132;
            const yPercent = ((e.clientY - top) / height) * 132;
        
            zoomedImage.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
        });
    }

    const deMagnifyImage = (event) => {
        const container = event.currentTarget;
        const zoomedImage = container.querySelector(".zoomed-image");
        zoomedImage.style.display = "none";
    }

    return (
        <Col className="p-1" xs={12} sm={12} md={8} lg={8} xl={8}>
            <Card className="h-100">
                <Card.Header className="card-height-50">
                    <Card.Title style={{ display: "flex", justifyContent: "space-between" }} className="font-weight-bold ml-3 f-17">
                        {props?.title + " Images"}
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <h5 style={{ fontWeight: "bold" }}>Zoom</h5>
                            {
                                ZOOM_LEVEL.map(level => 
                                    <div
                                        className={`zoom-image mx-2 ${utils.zoomLevel === level ? `selected-zoom` : ""}`}
                                        onClick={() => setUtils({ ...utils, zoomLevel: level })}
                                    >
                                        <span>{level}x</span>
                                    </div>
                                )
                            }
                        </div>
                        <ToolTip
                            toolTipKEy="Minimize"
                            toolTipValue="Minimize"
                            overlayComponent={
                                <Icon
                                    width={20}
                                    height={20}
                                    className="mr-2 cursor-pointer"
                                    icon={"feather-minimize"}
                                    onClick={() => dispatch({ type: MAXIMIZE_OR_MINIMIZE_IMAGE_SECTION, payload: "" })}
                                />
                            }
                        />
                    </Card.Title>
                </Card.Header>
                {
                    checkIfCurrentImageTypeIsComponent() &&
                        <Nav className="mx-1 my-2" justify variant="tabs" defaultActiveKey="link-0">
                            <Nav.Item onClick={() => setUtils({ ...utils, currentImageTab: ALL })} className="mx-1 font-weight-bold" style={{ border: "1px solid", borderRadius: "7px" }}>
                                <Nav.Link eventKey="link-0">{ALL}</Nav.Link>
                            </Nav.Item>
                            <Nav.Item onClick={() => setUtils({ ...utils, currentImageTab: COMPONENT })} className="mx-1 font-weight-bold" style={{ border: "1px solid", borderRadius: "7px" }}>
                                <Nav.Link eventKey="link-1">{COMPONENT}</Nav.Link>
                            </Nav.Item>
                            <Nav.Item onClick={() => setUtils({ ...utils, currentImageTab: LABEL })} className="mx-1 font-weight-bold" style={{ border: "1px solid", borderRadius: "7px" }}>
                                <Nav.Link eventKey="link-2">{LABEL}</Nav.Link>
                            </Nav.Item>
                        </Nav>
                }

                <Card.Body
                    style={{ borderTop: checkIfCurrentImageTypeIsComponent() && "1px solid #075978" }}
                    className={`p-2 h-100 ${
                            (
                                _.isEmpty(currentImages) ||
                                (_.isEmpty(currentImages?.component) && _.isEmpty(currentImages?.label))
                            ) &&
                            "no-image-found-expanded"
                        }`
                    }
                >
                    {
                        getPictures()
                    }
                    {
                        !_.isEmpty(utils.selectedImage.id) &&
                            <ImagePopup
                                target={props.target} closePopup={() => setUtils({ ...utils, selectedImage: {} })}
                                image={utils.selectedImage.image} imageId={utils.selectedImage.id}
                            />
                    }
                </Card.Body>
            </Card>
        </Col>
    )
}

export default ExpandedImageView;